<template>
  <!-- modal de détection de compte legacy -->
  <DialogComponent
    ref="migrationModal"
    type="bottomsheet"
    noInnerPadding
    hideCloseButton
  >
    <div class="p-6">
      <div class="text-xl font-bold mb-2 title-color">
        Compte détecté
      </div>
      <div class="text-sm text-slate-500 mb-6">
        Nous avons détecté un compte existant avec l'email <strong>{{ userMigrationStore.email }}</strong>.
        Pour continuer, vous devrez définir un nouveau mot de passe.
      </div>

      <div class="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
        <div class="flex items-start gap-3">
          <div class="text-blue-500 text-xl">ℹ️</div>
          <div class="text-sm text-blue-800">
            <p class="font-semibold mb-1">Migration de compte</p>
            <p>Vos données seront transférées vers notre nouveau système.</p>
          </div>
        </div>
      </div>

      <!-- boutons -->
      <div class="flex flex-col gap-3">
        <button
          @click="startMigration"
          class="buttonComponent py-4 w-full"
        >
          migrer mon compte
        </button>
        <button
          @click="skipMigration"
          class="buttonComponent py-4 w-full bg-slate-100! border border-primary text-primary!"
        >
          continuer manuellement
        </button>
      </div>
    </div>
  </DialogComponent>

  <!-- modal de confirmation pour continuer manuellement -->
  <DialogComponent
    ref="confirmSkipModal"
    type="bottomsheet"
    noInnerPadding
    hideCloseButton
  >
    <div class="p-6">
      <div class="text-xl font-bold mb-2 title-color text-red-600">
        Attention
      </div>
      <div class="text-sm text-slate-500 mb-6">
        Si vous continuez manuellement, vos anciennes données seront <strong>supprimées définitivement</strong>.
        Vous devrez créer un nouveau compte.
      </div>

      <!-- boutons -->
      <div class="flex gap-3">
        <button
          @click="$refs.confirmSkipModal?.hide()"
          class="flex-1! buttonComponent py-4 bg-slate-100! border border-primary text-primary!"
        >
          annuler
        </button>
        <button
          @click="confirmSkip"
          class="flex-1! buttonComponent py-4 bg-red-500! border-red-600! text-white!"
        >
          supprimer et continuer
        </button>
      </div>
    </div>
  </DialogComponent>
</template>

<script>
export default {
  name: 'UserMigration',

  computed: {
    userMigrationStore() {
      return this.$stores?.userMigration?.state || {
        email: null,
        firstName: null,
        lastName: null,
        reference: null,
        showModal: false
      };
    }
  },

  watch: {
    'userMigrationStore.showModal'(newValue) {
      if (newValue) {
        this.$refs.migrationModal?.show();
      } else {
        this.$refs.migrationModal?.hide();
      }
    }
  },

  methods: {
    startMigration() {
      this.$refs.migrationModal?.hide();
      this.$bus.emit(this.$constants.EVENTS.LEGACY_MIGRATION.START_MIGRATION, {
        email: this.userMigrationStore.email,
        firstName: this.userMigrationStore.firstName,
        lastName: this.userMigrationStore.lastName,
        reference: this.userMigrationStore.reference
      });
    },

    skipMigration() {
      this.$refs.migrationModal?.hide();
      this.$refs.confirmSkipModal?.show();
    },

    confirmSkip() {
      this.$refs.confirmSkipModal?.hide();
      this.$bus.emit(this.$constants.EVENTS.LEGACY_MIGRATION.CONFIRM_SKIP, {
        email: this.userMigrationStore.email
      });
    }
  }
};
</script>
